import {
  SnackbarColor,
  SnackbarSize,
  SnackbarVariant,
} from '@/contexts/SnackbarContext';
import { colorSemanticsArray } from '@/styles/theme';
import styled, { css, keyframes } from 'styled-components';
import { corTextoSnackbar } from '.';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

interface SnackbarProps {
  $size: SnackbarSize;
  $variant: SnackbarVariant;
  $color: SnackbarColor;
  $snackbarVisivel: boolean;
  $highContrast: boolean;
}

export const Container = styled.div<SnackbarProps>`
  position: fixed;
  bottom: ${({ theme }) => theme.spacing['6']}px;

  z-index: 1000;

  right: 0px;
  max-width: 275px;

  display: flex;
  align-items: center;

  animation: ${({ $snackbarVisivel }) =>
      $snackbarVisivel ? slideIn : slideOut}
    0.3s ease-in-out;
  transition: opacity 0.3s ease-in-out;
  opacity: ${({ $snackbarVisivel }) => ($snackbarVisivel ? 1 : 0)};

  border-radius: ${({ theme, $size }) =>
    theme.spacing[$size > 2 ? 2 : $size]}px;

  ${({ theme, $size }) => {
    if ($size === 1) {
      return css`
        padding-top: ${theme.spacing[3]}px;
        padding-right: ${theme.spacing[4]}px;
        padding-bottom: ${theme.spacing[3]}px;
        padding-left: ${theme.spacing[4]}px;
        gap: ${theme.spacing['2']}px;
      `;
    }
    return css`
      padding: ${theme.spacing[$size + 2]}px;
      gap: ${theme.spacing[$size + 1]}px;
    `;
  }}

  background-color: ${({ theme, $color, $highContrast }) => {
    if (colorSemanticsArray.includes($color))
      return theme.colors.semantic[$color][$highContrast ? 12 : 9];
    return theme.colors[$color][$color][9];
  }};

  ${({ theme, $size }) => {
    const tamanhoTexto = $size < 2 ? 2 : $size;
    return css`
      font-size: ${theme.typography.font.size[tamanhoTexto]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.medium};
      line-height: ${theme.typography.font.line_height[tamanhoTexto]}px;
    `;
  }}

  color: ${({ $color, $highContrast }) =>
    corTextoSnackbar({
      color: $color,
      highContrast: $highContrast,
    })};
`;
